import { Minus, Plus, Trash } from "lucide-react";
import { useCartStore } from "../stores/useCartStore";
import { getImageUrl } from "../lib/imageUtils";

const CartItem = ({ item }) => {
	const { removeFromCart, updateQuantity } = useCartStore();

	const getProductId = () => item.product?._id || item._id;
	const getImage = () => item.image || item.product?.imageUrl || (Array.isArray(item.product?.images) ? item.product.images[0] : undefined) || '/images/placeholder.svg';
	const getName = () => item.name || item.product?.name || '';
	const getPrice = () => (typeof item.price === 'number' ? item.price : item.product?.price) || 0;

	return (
		<div className='rounded-lg border p-4 shadow-sm border-gray-200 bg-white md:p-6'>
			<div className='space-y-4 md:flex md:items-center md:justify-between md:gap-6 md:space-y-0'>
				<div className='shrink-0 md:order-1'>
					<img 
						className='h-20 md:h-32 rounded object-cover' 
						src={getImageUrl(getImage())} 
						alt={getName()}
						onError={(e) => {
							e.target.src = '/images/placeholder.svg';
						}}
					/>
				</div>
				<label className='sr-only'>Choose quantity:</label>

				<div className='flex items-center justify-between md:order-3 md:justify-end'>
					<div className='flex items-center gap-2'>
						<button
						className='inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-md border
						 border-gray-300 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2
						  focus:ring-brand-primary'
							onClick={() => updateQuantity(getProductId(), item.quantity - 1)}
						>
						<Minus className='text-gray-600' />
						</button>
						<p>{item.quantity}</p>
						<button
						className='inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-md border
						 border-gray-300 bg-white hover:bg-gray-50 focus:outline-none 
						focus:ring-2 focus:ring-brand-primary'
							onClick={() => updateQuantity(getProductId(), item.quantity + 1)}
						>
						<Plus className='text-gray-600' />
						</button>
					</div>

					<div className='text-end md:order-4 md:w-32'>
					<p className='text-base font-bold text-brand-primary'>₪{getPrice()}</p>
					</div>
				</div>

				<div className='w-full min-w-0 flex-1 space-y-4 md:order-2 md:max-w-md'>
					<p className='text-base font-medium text-gray-900 text-brand-primary-hover hover:underline'>
						{getName()}
					</p>
					<p className='text-sm text-gray-400'>{item.description}</p>

					<div className='flex items-center gap-4'>
						<button
							className='inline-flex items-center text-sm font-medium text-red-400
							 hover:text-red-300 hover:underline'
						onClick={() => removeFromCart(getProductId())}
						>
							<Trash />
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};
export default CartItem;
